module.exports = __webpack_public_path__ + "static/img/code is next oil block.1bdef6a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code is next oil block.jpeg
// module id = B1Gn
// module chunks = 1